import { useEffect, useState } from "react";
import { canSpeak, speak, stopSpeaking } from "../speech";

/**
 * The answer, and the read-aloud control that sits under it. Read-aloud is not
 * an accessibility afterthought here — a six-year-old cannot read a paragraph,
 * so this is how most of them will consume the answer at all.
 */
export function Bubble({ text, autoRead }: { text: string; autoRead?: boolean }) {
  const [reading, setReading] = useState(false);

  useEffect(() => {
    if (autoRead && canSpeak()) {
      setReading(true);
      speak(text, () => setReading(false));
    }
    return () => {
      stopSpeaking();
      setReading(false);
    };
  }, [text, autoRead]);

  const toggle = () => {
    if (reading) {
      stopSpeaking();
      setReading(false);
      return;
    }
    setReading(true);
    speak(text, () => setReading(false));
  };

  return (
    <div className="rounded-3xl rounded-bl-lg bg-panel p-5 text-[19px] leading-relaxed text-cream">
      {text}
      {canSpeak() && (
        <button
          onClick={toggle}
          className="kidbtn mt-3 block text-[15px] font-extrabold text-cyan"
          aria-label={reading ? "Stop reading" : "Read it to me"}
        >
          {reading ? "⏹ Stop reading" : "🔊 Read it to me"}
        </button>
      )}
    </div>
  );
}
